import { Tween } from "@tweenjs/tween.js";
import { Ticker } from "pixi.js";
import { CancellationToken } from "../../composition/CancellationToken";

export class TweenUtils {
    public static tweenTo<T>(object: T, to: Partial<Record<keyof T, any>>, duration: number, cancellationToken?: CancellationToken, onUpdate?: (object: T, elapsed: number) => void): Promise<void> {
        const tween = new Tween(object);
        return new Promise((resolve, _reject) => {
            tween.to(to, duration);
            if (onUpdate != null) {
                tween.onUpdate(onUpdate);
            }
            tween.start();
            const onTick = () => tween.update();
            const onComplete = () => {
                cancellationToken?.onCanceled.remove(onComplete);
                Ticker.shared.remove(onTick);
                tween.onComplete(null);
                tween.onUpdate(null);
                tween.stop();
                resolve();
            };
            cancellationToken?.onCanceled.add(onComplete);
            Ticker.shared.add(onTick);
            tween.onComplete(onComplete);
        });
    }
}
